import cn from 'classnames';

import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { Hint } from 'CorePackage/MainModule/components/Hint';
import { KnmResultDecisionAgreementStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionAgreementStatusEnum';

import styles from './ResultDecisionsItemContentGeneral.module.scss';
import { ReactQuillEditorField } from '../../../../../../UIPackage/MainModule/components/ReactQuillEditorField';
import { IKnmFormRef } from '../../../../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from '../../../../../../DecisionPackage/MainModule/interfaces/IDecisionFormRef';

interface IResultDecisionsItemContentGeneralProps {
  isDisabledField: boolean;
  name: string;
  dateName: string;
  dateResolvedName: string;
  infoResolvedName: string;
  isHideInfoResolved: boolean;
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
  infoResolvedId?: string;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  agreementStatus: KnmResultDecisionAgreementStatusEnum | undefined;
}

export const ResultDecisionsItemContentGeneral = ({
  isDisabledField,
  dateName,
  dateResolvedName,
  infoResolvedName,
  isHideInfoResolved,
  isKnm,
  isPm,
  isDecision,
  infoResolvedId,
  formRef,
  name,
  agreementStatus,
}: IResultDecisionsItemContentGeneralProps) => {
  const canShowDateResolvedByAgreement =
    agreementStatus === KnmResultDecisionAgreementStatusEnum.AGREEMENT_APPROVED ||
    agreementStatus === KnmResultDecisionAgreementStatusEnum.AGREEMENT_COMPLETED;

  return (
    <div className={styles.Wrapper}>
      <FieldBlock label={'Основные сведения о решении'} />
      <Row>
        <FieldBlock
          label={'Дата предписания'}
          color="black"
          placementLabel="left"
          type="not-space"
          className={cn(styles.DateAndTimeCreation, styles.FieldBlock)}
        >
          <DatePickerField name={dateName} disabled={true} timeFormat />
        </FieldBlock>
      </Row>
      {canShowDateResolvedByAgreement && (
        <Row>
          <FieldBlock
            label={'Срок исполнения решения по соглашению'}
            color="black"
            placementLabel="left"
            type="not-space"
            className={styles.FieldBlock}
          >
            <DatePickerField
              className={styles.ErknmResultDecisionsItemContentInjunctionDate}
              name={`${name}.dateResolvedByAgreement`}
              disabled={true}
            />
          </FieldBlock>
        </Row>
      )}
      <Row>
        <FieldBlock
          label={'Срок исполнения предписания'}
          color="black"
          placementLabel="left"
          type="not-space"
          className={cn(styles.FieldBlock, styles.HasHint)}
        >
          <DatePickerField
            className={styles.ErknmResultDecisionsItemContentInjunctionDate}
            name={dateResolvedName}
            disabled={true}
          />
          {canShowDateResolvedByAgreement && (
            <div className={styles.Hint}>
              <Hint text="Срок приостановлен по соглашению" />
            </div>
          )}
        </FieldBlock>
      </Row>
      {!isHideInfoResolved && (
        <Row>
          <FieldBlock
            label={getTitleFieldWithRedStar({
              label:
                'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
              field: `${infoResolvedName}ReactQuillEditor`,
              isDecision,
              isKnm,
              isPm,
            })}
            color="black"
            placementLabel="left"
            type="not-space"
            className={styles.FieldBlock}
            id={`${infoResolvedId}ReactQuillEditor`}
          >
            <ReactQuillEditorField
              name={`${infoResolvedName}ReactQuillEditor`}
              handleCustomChange={(e: string) => {
                // @ts-ignore
                formRef?.current?.change(infoResolvedName as string, e);
              }}
              disabled={isDisabledField}
            />
          </FieldBlock>
        </Row>
      )}
    </div>
  );
};
